import type { DateTime } from "luxon";

export enum CGU_TYPE {
  TRANSACTION = "TRANSACTION",
  REGISTER = "REGISTER"
}
export type CguType = {
  UUID: string;
  UrlFr: string;
  UrlEn: string;
  Version: string;
  Type: CGU_TYPE;
};
export type SavedCguType = {
  UUID: string;
  CreatedAt: DateTime;
  TermUuid: string;
  TermVersion: string;
  TermType: CGU_TYPE;
};
